import type { ModuleManifest } from "./types";

export const invoiceDetailsManifest: ModuleManifest = {
  name: "invoice-details",
  label: "Invoice Detail",
  labelPlural: "Invoice Details",

  coreBOSModule: "InvoiceDetails",
  wsidPrefix: "70x",

  type: "standard",

  routes: {
    list: "/invoice-details",
    show: "/invoice-details/show/:id",
    create: "/invoice-details/create",
    edit: "/invoice-details/edit/:id",
  },

  navigation: {
    icon: "UnorderedListOutlined",
    order: 11,
    group: "Finance",
    hidden: true, // Detail modules are accessed via master, not directly
  },

  routing: {
    keywords: ["invoice detail", "invoice line", "invoice item"],
    searchFields: ["invoicedetailsno", "invoicedetailname"],
    defaultSort: { field: "nrline", order: "asc" },
  },

  context: {
    supported: false,
  },

  fields: [
    { name: "invoicedetailsno", label: "Detail No", type: "string", readonly: true },
    { name: "nrline", label: "Line Number", type: "string" },
    { name: "invoicedetailname", label: "Name", type: "string" },
    { name: "invoicedetailtomaster", label: "Invoice", type: "reference", referenceModule: "InvoiceMaster", required: true },
    { name: "invoicedetail_product", label: "Product", type: "reference", referenceModule: "Products" },
    { name: "invoicedetail_quantity", label: "Quantity", type: "string" },
    { name: "poteknema", label: "Description", type: "string" },
    { name: "posupplier", label: "Supplier", type: "string" },
    { name: "riferimento", label: "Reference", type: "string" },
    { name: "invoicedetail_project", label: "Project", type: "reference", referenceModule: "Project" },
    { name: "nota", label: "Notes", type: "text" },
    { name: "assigned_user_id", label: "Assigned To", type: "reference", referenceModule: "Users", hidden: true, defaultValue: "19x1" },
  ],

  relationships: [
    { module: "InvoiceMaster", field: "invoicedetailtomaster", label: "Invoice", icon: "FileTextOutlined", displayField: "invoicemastername" },
    { module: "Products", field: "invoicedetail_product", label: "Product", icon: "ShoppingOutlined", displayField: "productname" },
  ],

  requiredFields: ["invoicedetailtomaster", "assigned_user_id"],

  massEdit: {
    enabled: false,
  },
};
